import { PopupApiDto } from '@b2x/storefront-api-js-client/src/dto';

import { PopupBuilderButtonContentType, PopupContentTypeV2 } from '../contentTypes';
import { ModalButtonProps } from '../Modal';
import { storage } from '../storage';

// Minimized popups

const MINIMIZED_POPUPS_KEY = 'minimizedPopups';

// Recupero la lista di tutti i popup minimizzati persistente nel localStorage
export const getStoredMinimizedPopups = () => storage.getObject<Array<string>>(MINIMIZED_POPUPS_KEY, true, true) || [];

const setStoredMinimizedPopups = (minimizedPopups: Array<string>) =>
  storage.setObject(MINIMIZED_POPUPS_KEY, minimizedPopups, true, true);

// Aggiungo un popup minimizzato alla lista persistente nel localStorage
export const addStoredMinimizedPopup = (popupId: string) => {
  const minimizedPopups = getStoredMinimizedPopups();
  if (!minimizedPopups.includes(popupId)) {
    minimizedPopups.push(popupId);
  }
  setStoredMinimizedPopups(minimizedPopups);
};

// Rimuovo un popup minimizzato dalla lista persistente nel localStorage
export const removeStoredMinimizedPopup = (popupId: string) => {
  const minimizedPopups = getStoredMinimizedPopups();
  const filtered = minimizedPopups.filter((id) => id !== popupId);
  setStoredMinimizedPopups(filtered);
};

// Available actions

export type PopupAvailableActions = Record<string, (() => void) | undefined>;
const popupAvailableActions: PopupAvailableActions = {};

export const setPopupAvailableActions = (actions: PopupAvailableActions) => {
  Object.entries(actions).forEach(([key, action]) => {
    popupAvailableActions[key] = action;
  });
};

export const getPopupAvailableActions = () => popupAvailableActions;

export const popupBuilderButtonToModalButtonProps = (
  button: PopupBuilderButtonContentType,
  popup: PopupApiDto<PopupContentTypeV2>
): ModalButtonProps => {
  return {
    availableActions: getPopupAvailableActions(),
    callbacks:
      button.callback?.map((cb) => ({
        action: cb.action,
        close: popup.closable ? cb.close : undefined,
        couponCode: cb.applyCoupon ? popup.offer?.code : undefined,
        externalUrl: cb.externalUrl,
        minimize: popup.minimizable ? cb.minimize : undefined,
        redirect: cb.redirect?.at(0),
      })) || [],
    label: button.label,
    variant: button.variant,
  };
};
